export enum SalesCatalogueType {
    'Test',
    'Package',
    'TestBundle'
}
